import { BaseProduct, ProductBuilderMachineContext } from '../types';

type GetSlatSize = (context: ProductBuilderMachineContext) => string[];
type ProductHasSlatSizeOption = (product: BaseProduct) => boolean;
type GetVariantOptionKeyForSlatSize = (
  product: BaseProduct,
) => SlatSizeKey | null;

type SlatSizeKey = 'option1' | 'option2' | 'option3';
type ProductHasVariantWithSlatSize = (
  slatSize: string,
) => (product: BaseProduct) => boolean;

export const productHasSlatSizeOption: ProductHasSlatSizeOption = product =>
  product.options.includes('Slat Size');

export const getVariantOptionKeyForSlatSize: GetVariantOptionKeyForSlatSize = product => {
  const slatSizeIndex = product.options.findIndex(
    option => option === 'Slat Size',
  );
  if (slatSizeIndex === -1) return null;

  return `option${slatSizeIndex + 1}` as SlatSizeKey;
};

export const getSlatSize: GetSlatSize = context => {
  const { products } = context;

  const slatSizeKey =
    products.length > 0 ? getVariantOptionKeyForSlatSize(products[0]) : null;
  if (slatSizeKey === null) return [];

  return Array.from(
    new Set(
      products
        .map(({ variants }) =>
          variants.map(variant => {
            return variant[slatSizeKey] as string;
          }),
        )
        .flat(),
    ),
  );
};

export const productHasVariantWithSlatSize: ProductHasVariantWithSlatSize = slatSize => product => {
  const optionKey = getVariantOptionKeyForSlatSize(product);
  if (optionKey === null) return false;

  return product.variants.some(variant => variant[optionKey] === slatSize);
};
